// extracted by mini-css-extract-plugin
export default {"button-wrapper":"ProfileForm_button-wrapper__zMFQo"};